<!--PageHeader:页面标题 2024/03/07 17:09:50 YuAng-->

<template>
  <div class="page-header">
    <div class="header-left">
      <span v-if="!notBack" class="header-back" @click="back">
        <i class="el-icon-arrow-left"></i>返回
      </span>
      <span v-for="item, index in paths" :key="'path' + index" class="">
        {{ item }}<i v-show="index < paths.length - 1" class="el-icon-arrow-right"></i>
      </span>
    </div>
    <div class="header-middle">{{ title }}</div>
    <div class="header-right">
      <slot></slot>
    </div>
  </div>
</template>
<script>

export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      default: '页面业务标题'
    },
    paths: {
      type: Array,
      default: {
        return: []
      }
    },
    notBack: {
      type: Boolean,
      default: false
    },
    pageName: {
      type: String,
      default: ''
    },
    // 区域场景-是否使用区域返回
    useRegionBack: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    back () {
      if (this.$listeners.back) {
        this.$emit('back')
      } else {
        this.$router.back()
      }
    }
  }
}
</script>

<style scoped>
.page-header {
  display: flex;
  align-items: center;
  height: 40px;
  font-size: 14px;
  background-color: white;
  border-bottom: 1px solid #e5e5e5;
  padding: 0 16px;
  color: #999;
  line-height: 1.5;
}

.page-header i {
  font-style: normal;
}

.header-left,
.header-right {
  width: 300px;
}

.header-back {
  margin-right: 20px;
  cursor: pointer;
}

.header-back:hover {
  color: #2877ff !important;
}

.page-header span:first-child,
.page-header span:last-child {
  color: #333;
}

.header-middle {
  flex: 1;
  text-align: center;
  color: #333;
  font-weight: 500;
  font-size: 16px;
}

.el-icon-arrow-right {
  margin: 0 4px;
}
</style>